import { RouteConfig } from '@/common/types';
import { useFeatureFlagsStore } from '@/features/feature-flags/presentation/bloc/feature-flags-bloc';

export const getVisibleRoutes = (routes: RouteConfig[]) => {
  const featureFlagsStore = useFeatureFlagsStore();

  return routes.filter(({ hiddenFeature }) => !hiddenFeature || featureFlagsStore.isEnabled(hiddenFeature));
};
